import { Participante } from '../participantes/participante';

export class Upload{
  id: number;
  upload_id: number;
  nome: string;
  documento_id: number;
  participantes: Participante[];
  arquivo: File;

}



// WEBPACK FOOTER //
// ./src/app/uploads/upload.ts